<script>
    import { gameStarted, paused } from '../stores.js';

    function handleClick() {
        paused.set(!$paused);
    }
</script>

{#if $gameStarted}
    <button class="mui-btn mui-btn--primary mui-btn--raised" on:click={handleClick}>
        {!$paused ? 'Pause' : 'Resume'}
    </button>
{/if}